import { ParserInput } from 'src/services/DB';
import { dataAndID } from 'src/store/parsers/dataandid';
import { CollectionBookmark } from 'src/types/models/collectionBookmark.model';
export function collectionBookmarkParser(
  doc: ParserInput,
): CollectionBookmark | null {
  return dataAndID<CollectionBookmark>(doc);
}
